import { ApiClient } from '@guiker/blog-api-client'

import { config } from '../config'

const getApiClient = () => ApiClient(config)

export { getApiClient }
